const lodashOmit = require("lodash.omit");
const lodashIsEqual = require("lodash.isequal");
const jwt = require("jsonwebtoken");

exports.generateRequestHeaders = (accessToken) => ({
    headers: {
        Authorization: 'Bearer ' + accessToken
    },
})

exports.getRegionNameFromEnvVariables = ({ useShorthand } = { useShorthand: false }) => {
    switch (process.env.REGION) {
        case 'australia-southeast1':
            return useShorthand ? 'AU' : 'Australia 🇦🇺'
        case 'us-east1':
            return useShorthand ? 'US' : 'North America 🇺🇸'
        case 'europe-west1':
            return useShorthand ? 'EU' :'Europe 🇪🇺'
        default:
            return 'Rest of the World'
    }
}

exports.truncateString = (str, numberOfChars) => {
    if (str.length <= numberOfChars) {
        return str
    }

    return `${str.substring(0, numberOfChars)}...`
}

exports.timeout = (ms) => new Promise(res => setTimeout(res, ms))

exports.getConfigParamsTemplateName = (project, configParams) => {
    if (
      !project.configurationParameters ||
      !project.configurationParameters.iosConfig ||
      !project.configurationParameters.androidConfig
    ) {
      return "no template";
    }

    // Find the config params template being used
    const configParamsTemplate  = configParams.length && configParams.find((params) => {
        const { androidConfig, iosConfig } = params;

        const isIosEqual = lodashIsEqual(
          lodashOmit(iosConfig, ["applicationLoggingEnabled", "tempo"]),
          lodashOmit(project?.configurationParameters?.iosConfig, ["applicationLoggingEnabled", "tempo"])
        );

        const isAndroidEqual = lodashIsEqual(
          lodashOmit(androidConfig, ["applicationLoggingEnabled", "tempo"]),
          lodashOmit(project?.configurationParameters?.androidConfig, ["applicationLoggingEnabled", "tempo"])
        );

        return isIosEqual && isAndroidEqual;
    });


    if (!configParamsTemplate) {
      return "custom template";
    }

    return configParamsTemplate.name;
  };

exports.createCancellationToken = () => {
    return {
        shouldCancel: false,
        cancel(){
            this.shouldCancel = true
        }
    }
}

function debounce(fn, delay=200) {
    let timer = null;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, delay);
    };
}

exports.debounce = debounce

exports.isHexColorValid = (hexColor) => {
    const hexRegex = new RegExp(/^#((?:[0-9a-fA-F]{3}){1,2}|(?:[0-9a-fA-F]{4}){1,2})$/)
    return hexRegex.test(hexColor)
}

const decodeJwt = (token) => {
    const withoutBearer = token.split(" ")[1];
    return jwt.decode(withoutBearer, { complete: true });
};

exports.getUserIdFromToken = (token) => {
    const decodedJwt = decodeJwt(token);
    return decodedJwt.payload.dbUser || decodedJwt.payload.sub;
};

exports.getUsernameFromToken = (token) => {
    const decodedJwt = decodeJwt(token);
    return decodedJwt.payload.email;
};